var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPersonality = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 39,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 32,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 39,
    r: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 32,
    r: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37 49h-.101c-.465 2.279-2.484 4-4.899 4s-4.434-1.721-4.899-4h-.101c-4.963 0-9 4.037-9 9v3h4v-6h2v6h16v-6h2v6h4v-3c0-4.963-4.037-9-9-9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m41 40c0 .338-.022.671-.059 1h.059c1.103 0 2-.897 2-2s-.897-2-2-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23 31v4h1 4c2.757 0 5-2.243 5-5v-1h2v1 3c0 1.103.897 2 2 2h3 1v-4c0-3.309-2.691-6-6-6h-6c-3.309 0-6 2.691-6 6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m39 40v-3h-2c-1.658 0-3.082-1.014-3.688-2.454-1.285 1.499-3.188 2.454-5.312 2.454h-3v3c0 3.859 3.141 7 7 7s7-3.141 7-7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21 39c0 1.103.897 2 2 2h.059c-.037-.329-.059-.662-.059-1v-3c-1.103 0-2 .897-2 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m32 51c1.302 0 2.402-.839 2.816-2h-5.631c.413 1.161 1.513 2 2.815 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m25 14c0-6.065-4.935-11-11-11s-11 4.935-11 11 4.935 11 11 11 11-4.935 11-11zm-6-5c2.206 0 4 1.794 4 4h-2c0-1.103-.897-2-2-2s-2 .897-2 2h-2c0-2.206 1.794-4 4-4zm-12 4h-2c0-2.206 1.794-4 4-4s4 1.794 4 4h-2c0-1.103-.897-2-2-2s-2 .897-2 2zm3 4h2c0 1.103.897 2 2 2s2-.897 2-2h2c0 2.206-1.794 4-4 4s-4-1.794-4-4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m50 3c-6.065 0-11 4.935-11 11s4.935 11 11 11 11-4.935 11-11-4.935-11-11-11zm-9 7h2c0 1.103.897 2 2 2s2-.897 2-2h2c0 2.206-1.794 4-4 4s-4-1.794-4-4zm11 10c0-1.103-.897-2-2-2s-2 .897-2 2h-2c0-2.206 1.794-4 4-4s4 1.794 4 4zm3-6c-2.206 0-4-1.794-4-4h2c0 1.103.897 2 2 2s2-.897 2-2h2c0 2.206-1.794 4-4 4z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPersonality, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/personality.7b81a065.svg";
export { ForwardRef as ReactComponent };